import { runIfDev } from "../utils";

function isObject(arg: any) {
	return Object.prototype.toString.call(arg) === '[object Object]';
}

export const formDataToObject = (elForm: Element) => {
	if (!(elForm instanceof Element)) return {};
	const fields = elForm.querySelectorAll('input, select, textarea')
	const o = {};

	for (let i = 0, imax = fields.length; i < imax; ++i) {
		const field = fields[i] as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
		const sKey = field.name || field.id;

		if (field.type === 'button' || field.type === 'image' || field.type === 'submit' || !sKey) continue;

		switch (field.type) {
			case 'checkbox':
				o[sKey] = +(field as HTMLInputElement).checked;
				break;
			case 'radio':
				if (o[sKey] === undefined) o[sKey] = '';
				if ((field as HTMLInputElement).checked) o[sKey] = field.value;
				break;
			case 'select-multiple':
				const a = [];
				const selectField = field as HTMLSelectElement;
				for (var j = 0, jmax = selectField.options.length; j < jmax; ++j) {
					if (selectField.options[j].selected) a.push(selectField.options[j].value);
				}
				o[sKey] = a;
				break;
			default:
				o[sKey] = field.value;
		}
	}

	runIfDev(() => console.debug('Form data', o));

	return o;
}

export const populateForm = (o: any) => {
	if (!isObject(o)) return;

	for (let i in o) {
		const el = (document.getElementById(i) || document.querySelector('[name=' + i + ']')) as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

		if (el.type === 'radio') {
			const radios = document.querySelectorAll('[name=' + i + ']') as NodeListOf<HTMLInputElement>;
			radios.forEach(radio => {
				if (radio.value === o[i]) radio.checked = true;
			})
			continue;
		}

		switch (typeof o[i]) {
			case 'number':
				(el as HTMLInputElement).checked = o[i] as any;
				break;
			case 'object':
				const selectField = el as HTMLSelectElement;
				if (selectField.options && o[i] instanceof Array) {
					for (var j = 0, jmax = selectField.options.length; j < jmax; ++j) {
						if (o[i].indexOf(selectField.options[j].value) > -1) selectField.options[j].selected = true;
					}
				}
				break;
			default:
				el.value = o[i];
		}
	}
}